export enum DocumentRevisionStatus {
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  APPROVED = 'APPROVED',
  FAILED_APPROVAL = 'FAILED_APPROVAL',
  PENDING_VERIFICATION = 'PENDING_VERIFICATION',
  VERIFIED = 'VERIFIED',
  FAILED_VERIFICATION = 'FAILED_VERIFICATION',
  CURRENT = 'CURRENT',
  OBSOLETE = 'OBSOLETE',
  INACTIVE = 'INACTIVE',
  PENDING_TEST_CONTENT = 'PENDING_TEST_CONTENT',
  VALIDATED = 'VALIDATED',
  IN_USE = 'IN_USE',
  ARCHIVED = 'ARCHIVED',
}

export enum DocumentType {
  DOCUMENT = 'DOCUMENT',
  REGISTRATION = 'REGISTRATION',
}

export type DocumentRevisionStatusType = keyof typeof DocumentRevisionStatus;

export const DocumentRevisionStatusLabels: Record<DocumentRevisionStatus, string> = {
  [DocumentRevisionStatus.PENDING_APPROVAL]: 'Aguardando Aprovação',
  [DocumentRevisionStatus.APPROVED]: 'Aprovado',
  [DocumentRevisionStatus.FAILED_APPROVAL]: 'Reprovado na Aprovação',
  [DocumentRevisionStatus.PENDING_VERIFICATION]: 'Aguardando Verificação',
  [DocumentRevisionStatus.VERIFIED]: 'Aguardando Vigência',
  [DocumentRevisionStatus.FAILED_VERIFICATION]: 'Reprovado na Verificação',
  [DocumentRevisionStatus.CURRENT]: 'Vigente',
  [DocumentRevisionStatus.OBSOLETE]: 'Obsoleto',
  [DocumentRevisionStatus.INACTIVE]: 'Inativo',
  [DocumentRevisionStatus.PENDING_TEST_CONTENT]: 'Aguardando CP',
  [DocumentRevisionStatus.VALIDATED]: 'Validado',
  [DocumentRevisionStatus.IN_USE]: 'Em Uso',
  [DocumentRevisionStatus.ARCHIVED]: 'Arquivado',
};

/**
 * Short labels of the homologation steps, used where the column is narrow: the Status column of
 * both Homologação tabs, the filter and the top of the detail screens. "Aguardando VG" exists
 * only here; the long label stays "Aguardando Vigência", which is how the rest of the system
 * names the status.
 */
export const DocumentRevisionStatusShortLabels: Record<string, string> = {
  [DocumentRevisionStatus.PENDING_APPROVAL]: 'Aguardando AP',
  [DocumentRevisionStatus.APPROVED]: 'Aprovado',
  [DocumentRevisionStatus.FAILED_APPROVAL]: 'Reprovado AP',
  [DocumentRevisionStatus.PENDING_VERIFICATION]: 'Aguardando VF',
  [DocumentRevisionStatus.VERIFIED]: 'Aguardando VG',
  [DocumentRevisionStatus.FAILED_VERIFICATION]: 'Reprovado VF',
  [DocumentRevisionStatus.CURRENT]: 'Vigente',
  [DocumentRevisionStatus.OBSOLETE]: 'Obsoleto',
  [DocumentRevisionStatus.PENDING_TEST_CONTENT]: 'Aguardando CP',
};

export const DocumentRevisionStatusColors: Record<DocumentRevisionStatus, string> = {
  [DocumentRevisionStatus.PENDING_APPROVAL]: 'text-yellow-600',
  [DocumentRevisionStatus.APPROVED]: 'text-blue-600',
  [DocumentRevisionStatus.FAILED_APPROVAL]: 'text-red-600',
  [DocumentRevisionStatus.PENDING_VERIFICATION]: 'text-orange-600',
  [DocumentRevisionStatus.VERIFIED]: 'text-purple-600',
  [DocumentRevisionStatus.FAILED_VERIFICATION]: 'text-red-600',
  [DocumentRevisionStatus.CURRENT]: 'text-green-600',
  [DocumentRevisionStatus.OBSOLETE]: 'text-gray-600',
  [DocumentRevisionStatus.INACTIVE]: 'text-gray-600',
  [DocumentRevisionStatus.PENDING_TEST_CONTENT]: 'text-amber-600',
  [DocumentRevisionStatus.VALIDATED]: 'text-blue-600',
  [DocumentRevisionStatus.IN_USE]: 'text-green-700',
  [DocumentRevisionStatus.ARCHIVED]: 'text-gray-500',
};

export const ALLOWED_STATUSES_BY_TYPE: Record<DocumentType, DocumentRevisionStatus[]> = {
  [DocumentType.DOCUMENT]: [DocumentRevisionStatus.CURRENT, DocumentRevisionStatus.OBSOLETE, DocumentRevisionStatus.INACTIVE],
  [DocumentType.REGISTRATION]: [
    DocumentRevisionStatus.VALIDATED,
    DocumentRevisionStatus.IN_USE,
    DocumentRevisionStatus.ARCHIVED,
  ],
};
